import React from "react";
import translateString from "./Locales";

export default class Constants extends React.Component {

    static apisFolder = '/apis/'; 

    
    static ipAddress = 'www.hdemia.cloud';
    static mainUrl = 'www.hdemia.cloud' + Constants.apisFolder;
    static basicUrl = 'www.hdemia.cloud/';
    static defaultProtocol = 'https://';
    static PdfTitleFontSize = 11;
    static PdfNormalFontSize = 10;
    static PdfFooterFontSize = 9; 

}

export function demoEmailBody(ragSoc, db) {

    let t = translateString;
    
    var strVar="";
    strVar += "<!DOCTYPE HTML PUBLIC \"-\/\/W3C\/\/DTD XHTML 1.0 Transitional \/\/EN\" \"http:\/\/www.w3.org\/TR\/xhtml1\/DTD\/xhtml1-transitional.dtd\">";
    strVar += "<html xmlns=\"http:\/\/www.w3.org\/1999\/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">";
    strVar += "<head>";
    strVar += "<!--[if gte mso 9]>";
    strVar += "<xml>";
    strVar += "  <o:OfficeDocumentSettings>";
    strVar += "    <o:AllowPNG\/>";
    strVar += "    <o:PixelsPerInch>96<\/o:PixelsPerInch>";
    strVar += "  <\/o:OfficeDocumentSettings>";
    strVar += "<\/xml>";
    strVar += "<![endif]-->";
    strVar += "  <meta http-equiv=\"Content-Type\" content=\"text\/html; charset=UTF-8\">";
    strVar += "  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">";
    strVar += "  <meta name=\"x-apple-disable-message-reformatting\">";
    strVar += "  <!--[if !mso]><!--><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><!--<![endif]-->";
    strVar += "  <title><\/title>";
    strVar += "  ";
    strVar += "    <style type=\"text\/css\">";
    strVar += "      @media only screen and (min-width: 570px) {";
    strVar += "  .u-row {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    vertical-align: top;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-50 {";
    strVar += "    width: 275px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-100 {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 570px) {";
    strVar += "  .u-row-container {";
    strVar += "    max-width: 100% !important;";
    strVar += "    padding-left: 0px !important;";
    strVar += "    padding-right: 0px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    min-width: 320px !important;";
    strVar += "    max-width: 100% !important;";
    strVar += "    display: block !important;";
    strVar += "  }";
    strVar += "  .u-row {";
    strVar += "    width: calc(100% - 40px) !important;";
    strVar += "  }";
    strVar += "  .u-col {";
    strVar += "    width: 100% !important;";
    strVar += "  }";
    strVar += "  .u-col > div {";
    strVar += "    margin: 0 auto;";
    strVar += "  }";
    strVar += "}";
    strVar += "body {";
    strVar += "  margin: 0;";
    strVar += "  padding: 0;";
    strVar += "}";
    strVar += "";
    strVar += "table,";
    strVar += "tr,";
    strVar += "td {";
    strVar += "  vertical-align: top;";
    strVar += "  border-collapse: collapse;";
    strVar += "}";
    strVar += "";
    strVar += "p {";
    strVar += "  margin: 0;";
    strVar += "}";
    strVar += "";
    strVar += ".ie-container table,";
    strVar += ".mso-container table {";
    strVar += "  table-layout: fixed;";
    strVar += "}";
    strVar += "";
    strVar += "* {";
    strVar += "  line-height: inherit;";
    strVar += "}";
    strVar += "";
    strVar += "a[x-apple-data-detectors='true'] {";
    strVar += "  color: inherit !important;";
    strVar += "  text-decoration: none !important;";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 480px) {";
    strVar += "  .hide-mobile {";
    strVar += "    max-height: 0px;";
    strVar += "    overflow: hidden;";
    strVar += "    display: none !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "table, td { color: #000000; } a { color: #0000ee; text-decoration: underline; } @media (max-width: 480px) { #u_content_image_1 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_1 .v-src-width { width: auto !important; } #u_content_image_1 .v-src-max-width { max-width: 66% !important; } #u_content_image_2 .v-src-width { width: 100% !important; } #u_content_image_2 .v-src-max-width { max-width: 100% !important; } #u_content_image_5 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_5 .v-src-width { width: auto !important; } #u_content_image_5 .v-src-max-width { max-width: 45% !important; } #u_content_image_5 .v-text-align { text-align: center !important; } #u_content_image_4 .v-container-padding-padding { padding: 10px 10px 30px !important; } #u_content_image_4 .v-src-width { width: auto !important; } #u_content_image_4 .v-src-max-width { max-width: 45% !important; } #u_content_image_4 .v-text-align { text-align: center !important; } #u_content_menu_1 .v-container-padding-padding { padding: 10px !important; } }";
    strVar += "    <\/style>";
    strVar += "  ";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if !mso]><!--><link href=\"https:\/\/fonts.googleapis.com\/css?family=Cabin:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><link href=\"https:\/\/fonts.googleapis.com\/css?family=Lato:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><!--<![endif]-->";
    strVar += "";
    strVar += "<\/head>";
    strVar += "";
    strVar += "<body class=\"clean-body u_body\" style=\"margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #e0e5eb;color: #000000\">";
    strVar += "  <!--[if IE]><div class=\"ie-container\"><![endif]-->";
    strVar += "  <!--[if mso]><div class=\"mso-container\"><![endif]-->";
    strVar += "  <table style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #e0e5eb;width:100%\" cellpadding=\"0\" cellspacing=\"0\">";
    strVar += "  <tbody>";
    strVar += "  <tr style=\"vertical-align: top\">";
    strVar += "    <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top\">";
    strVar += "    <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td align=\"center\" style=\"background-color: #e0e5eb;\"><![endif]-->";
    strVar += "    ";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px 10px 30px 50px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\">";
    strVar += "      <img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-3.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 34%;max-width: 73.1px;\" width=\"73.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      <\/a>";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:15px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h1 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: comic sans ms,sans-serif; font-size: 35px;\">";
    strVar += "    " + t('pronti_partire');
    strVar += "  <\/h1>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px 30px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h3 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: book antiqua,palatino; font-size: 18px;\">";
    strVar += "    " + t('completato_steps');
    strVar += "  <\/h3>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_2\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"center\">";
    strVar += "      ";
    strVar += "      <img align=\"center\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-5.jpg\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 100%;max-width: 550px;\" width=\"550\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('account_c') + "<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"v-text-align\" align=\"center\">";
    strVar += "  <!--[if mso]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;\"><tr><td class=\"v-text-align\" style=\"font-family:'Lato',sans-serif;\" align=\"center\"><v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" style=\"height:39px; v-text-anchor:middle; width:98px;\" arcsize=\"14%\" stroke=\"f\" fillcolor=\"#e67e23\"><w:anchorlock\/><center style=\"color:#ffffff;font-family:'Lato',sans-serif;\"><![endif]-->";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" target=\"_blank\" style=\"box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #ffffff; background-color: #e67e23; border-radius: 10px 1px 10px 1px;-webkit-border-radius: 10px 1px 10px 1px; -moz-border-radius: 10px 1px 10px 1px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;border-top-width: 0px; border-top-style: solid; border-top-color: #CCC; border-left-width: 0px; border-left-style: solid; border-left-color: #CCC; border-right-width: 0px; border-right-style: solid; border-right-color: #CCC; border-bottom-width: 0px; border-bottom-style: solid; border-bottom-color: #CCC;\">";
    strVar += "      <span style=\"display:block;padding:10px 30px;line-height:120%;\"><span style=\"font-size: 16px; line-height: 19.2px; font-family: Lato, sans-serif;\">Login<\/span><\/span>";
    strVar += "    <\/a>";
    strVar += "  <!--[if mso]><\/center><\/v:roundrect><\/td><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('questioni_sicurezza') + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;<\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%;\"><a rel=\"noopener\" href=\"https:\/\/www.Hdemia.cloud\/"  + db + "\" target=\"_blank\">" + "https://www.Hdemia.cloud\/" + db + "<\/a><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_5\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"right\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/apps.apple.com\/us\/app\/appius-academy\/id1630916391\"><img align=\"right\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-1.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 139.65px;\" width=\"139.65\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_4\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/play.google.com\/store\/apps\/details?id=com.appiusacademy\"><img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-2.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 133.95px;\" width=\"133.95\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_menu_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"menu\" style=\"text-align:center\">";
    strVar += "<!--[if (mso)|(IE)]><table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\"><tr><![endif]-->";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('chi_siamo');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "    <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "    <span style=\"padding:5px 15px;display:inline-block;color:#7e8c8d;font-family:'Cabin',sans-serif;font-size:14px\" class=\"hide-mobile\">";
    strVar += "      |";
    strVar += "    <\/span>";
    strVar += "    <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"mailto:info@appius.it?subject=Info%20Appius%20Academy&body=\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('contattaci_m');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if (mso)|(IE)]><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 10px 15px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #7e8c8d; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\">&copy; 2022 Appius Srls. All Rights Reserved.<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "    <!--[if (mso)|(IE)]><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "  <\/table>";
    strVar += "  <!--[if mso]><\/div><![endif]-->";
    strVar += "  <!--[if IE]><\/div><![endif]-->";
    strVar += "<\/body>";
    strVar += "";
    strVar += "<\/html>";
    strVar += "";
    

    return strVar;

}

export function verifyMailBody(ragSoc, token, db) {

    let t = translateString;

    var strVar="";
    strVar += "<!DOCTYPE HTML PUBLIC \"-\/\/W3C\/\/DTD XHTML 1.0 Transitional \/\/EN\" \"http:\/\/www.w3.org\/TR\/xhtml1\/DTD\/xhtml1-transitional.dtd\">";
    strVar += "<html xmlns=\"http:\/\/www.w3.org\/1999\/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">";
    strVar += "<head>";
    strVar += "  <meta http-equiv=\"Content-Type\" content=\"text\/html; charset=UTF-8\">";
    strVar += "  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">";
    strVar += "  <meta name=\"x-apple-disable-message-reformatting\">";
    strVar += "  <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">";
    strVar += "  <title><\/title>";
    strVar += "  ";
    strVar += "    <style type=\"text\/css\">";
    strVar += "      @media only screen and (min-width: 570px) {";
    strVar += "  .u-row {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    vertical-align: top;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-50 {";
    strVar += "    width: 275px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-100 {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 570px) {";
    strVar += "  .u-row-container {";
    strVar += "    max-width: 100% !important;";
    strVar += "    padding-left: 0px !important;";
    strVar += "    padding-right: 0px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    min-width: 320px !important;";
    strVar += "    max-width: 100% !important;";
    strVar += "    display: block !important;";
    strVar += "  }";
    strVar += "  .u-row {";
    strVar += "    width: calc(100% - 40px) !important;";
    strVar += "  }";
    strVar += "  .u-col {";
    strVar += "    width: 100% !important;";
    strVar += "  }";
    strVar += "  .u-col > div {";
    strVar += "    margin: 0 auto;";
    strVar += "  }";
    strVar += "}";
    strVar += "body {";
    strVar += "  margin: 0;";
    strVar += "  padding: 0;";
    strVar += "}";
    strVar += "";
    strVar += "table,";
    strVar += "tr,";
    strVar += "td {";
    strVar += "  vertical-align: top;";
    strVar += "  border-collapse: collapse;";
    strVar += "}";
    strVar += "";
    strVar += "p {";
    strVar += "  margin: 0;";
    strVar += "}";
    strVar += "";
    strVar += ".ie-container table,";
    strVar += ".mso-container table {";
    strVar += "  table-layout: fixed;";
    strVar += "}";
    strVar += "";
    strVar += "* {";
    strVar += "  line-height: inherit;";
    strVar += "}";
    strVar += "";
    strVar += "a[x-apple-data-detectors='true'] {";
    strVar += "  color: inherit !important;";
    strVar += "  text-decoration: none !important;";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 480px) {";
    strVar += "  .hide-mobile {";
    strVar += "    max-height: 0px;";
    strVar += "    overflow: hidden;";
    strVar += "    display: none !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "table, td { color: #000000; } a { color: #0000ee; text-decoration: underline; } @media (max-width: 480px) { #u_content_image_1 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_1 .v-src-width { width: auto !important; } #u_content_image_1 .v-src-max-width { max-width: 66% !important; } #u_content_image_2 .v-src-width { width: auto !important; } #u_content_image_2 .v-src-max-width { max-width: 55% !important; } #u_content_image_5 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_5 .v-src-width { width: auto !important; } #u_content_image_5 .v-src-max-width { max-width: 45% !important; } #u_content_image_5 .v-text-align { text-align: center !important; } #u_content_image_4 .v-container-padding-padding { padding: 10px 10px 30px !important; } #u_content_image_4 .v-src-width { width: auto !important; } #u_content_image_4 .v-src-max-width { max-width: 45% !important; } #u_content_image_4 .v-text-align { text-align: center !important; } #u_content_menu_1 .v-container-padding-padding { padding: 10px !important; } }";
    strVar += "    <\/style>";
    strVar += "  ";
    strVar += "  ";
    strVar += "";
    strVar += "<link href=\"https:\/\/fonts.googleapis.com\/css?family=Cabin:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><link href=\"https:\/\/fonts.googleapis.com\/css?family=Lato:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\">";
    strVar += "";
    strVar += "<\/head>";
    strVar += "";
    strVar += "<body class=\"clean-body u_body\" style=\"margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #e0e5eb;color: #000000\">";
    strVar += "  <!--[if IE]><div class=\"ie-container\"><![endif]-->";
    strVar += "  <!--[if mso]><div class=\"mso-container\"><![endif]-->";
    strVar += "  <table style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #e0e5eb;width:100%\" cellpadding=\"0\" cellspacing=\"0\">";
    strVar += "  <tbody>";
    strVar += "  <tr style=\"vertical-align: top\">";
    strVar += "    <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top\">";
    strVar += "    <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td align=\"center\" style=\"background-color: #e0e5eb;\"><![endif]-->";
    strVar += "    ";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px 10px 30px 50px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\">";
    strVar += "      <img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-3.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 34%;max-width: 73.1px;\" width=\"73.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      <\/a>";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ebebeb;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ebebeb;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:15px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h1 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: comic sans ms,sans-serif; font-size: 35px;\">";
    strVar += "    " + t('ciao_m') + ragSoc + t('verifica_m');
    strVar += "  <\/h1>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px 30px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h3 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: book antiqua,palatino; font-size: 18px;\">";
    strVar += "    " + t('sicurezza_m');
    strVar += "  <\/h3>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ebebeb;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ebebeb;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_2\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"center\">";
    strVar += "      ";
    strVar += "      <img align=\"center\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-8.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 39%;max-width: 191.1px;\" width=\"191.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"v-text-align\" align=\"center\">";
    strVar += "  <!--[if mso]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;\"><tr><td class=\"v-text-align\" style=\"font-family:'Lato',sans-serif;\" align=\"center\"><v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" style=\"height:39px; v-text-anchor:middle; width:98px;\" arcsize=\"14%\" stroke=\"f\" fillcolor=\"#e67e23\"><w:anchorlock\/><center style=\"color:#ffffff;font-family:'Lato',sans-serif;\"><![endif]-->";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\/#\/main\/verify?token=" + token + "&db=" + db + "\" target=\"_blank\" style=\"box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #ffffff; background-color: #e67e23; border-radius: 10px 1px 10px 1px;-webkit-border-radius: 10px 1px 10px 1px; -moz-border-radius: 10px 1px 10px 1px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;border-top-width: 0px; border-top-style: solid; border-top-color: #CCC; border-left-width: 0px; border-left-style: solid; border-left-color: #CCC; border-right-width: 0px; border-right-style: solid; border-right-color: #CCC; border-bottom-width: 0px; border-bottom-style: solid; border-bottom-color: #CCC;\">";
    strVar += "      <span style=\"display:block;padding:10px 30px;line-height:120%;\"><span style=\"font-size: 16px; line-height: 19.2px; font-family: Lato, sans-serif;\">" + t('verifica_b') + "<\/span><\/span>";
    strVar += "    <\/a>";
    strVar += "  <!--[if mso]><\/center><\/v:roundrect><\/td><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_5\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"right\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/apps.apple.com\/us\/app\/appius-academy\/id1630916391\"><img align=\"right\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-1.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 139.65px;\" width=\"139.65\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_4\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/play.google.com\/store\/apps\/details?id=com.appiusacademy\"><img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-2.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 133.95px;\" width=\"133.95\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_menu_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"menu\" style=\"text-align:center\">";
    strVar += "<!--[if (mso)|(IE)]><table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\"><tr><![endif]-->";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      Chi siamo";
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "    <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "    <span style=\"padding:5px 15px;display:inline-block;color:#7e8c8d;font-family:'Cabin',sans-serif;font-size:14px\" class=\"hide-mobile\">";
    strVar += "      |";
    strVar += "    <\/span>";
    strVar += "    <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"mailto:info@appius.it?subject=Info%20Appius%20Academy&body=\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      Contattaci";
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if (mso)|(IE)]><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 10px 15px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #7e8c8d; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\">&copy; 2022 Appius Srls. All Rights Reserved.<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "    <!--[if (mso)|(IE)]><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "  <\/table>";
    strVar += "  <!--[if mso]><\/div><![endif]-->";
    strVar += "  <!--[if IE]><\/div><![endif]-->";
    strVar += "<\/body>";
    strVar += "";
    strVar += "<\/html>";
    strVar += "";
    
    return strVar;
}

export function newUserEmailBody(nome) {

    let t = translateString;
    
    var strVar="";
    strVar += "<!DOCTYPE HTML PUBLIC \"-\/\/W3C\/\/DTD XHTML 1.0 Transitional \/\/EN\" \"http:\/\/www.w3.org\/TR\/xhtml1\/DTD\/xhtml1-transitional.dtd\">";
    strVar += "<html xmlns=\"http:\/\/www.w3.org\/1999\/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">";
    strVar += "<head>";
    strVar += "  <meta http-equiv=\"Content-Type\" content=\"text\/html; charset=UTF-8\">";
    strVar += "  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">";
    strVar += "  <meta name=\"x-apple-disable-message-reformatting\">";
    strVar += "  <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">";
    strVar += "  <title><\/title>";
    strVar += "  ";
    strVar += "    <style type=\"text\/css\">";
    strVar += "      @media only screen and (min-width: 570px) {";
    strVar += "  .u-row {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    vertical-align: top;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-50 {";
    strVar += "    width: 275px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-100 {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 570px) {";
    strVar += "  .u-row-container {";
    strVar += "    max-width: 100% !important;";
    strVar += "    padding-left: 0px !important;";
    strVar += "    padding-right: 0px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    min-width: 320px !important;";
    strVar += "    max-width: 100% !important;";
    strVar += "    display: block !important;";
    strVar += "  }";
    strVar += "  .u-row {";
    strVar += "    width: calc(100% - 40px) !important;";
    strVar += "  }";
    strVar += "  .u-col {";
    strVar += "    width: 100% !important;";
    strVar += "  }";
    strVar += "  .u-col > div {";
    strVar += "    margin: 0 auto;";
    strVar += "  }";
    strVar += "}";
    strVar += "body {";
    strVar += "  margin: 0;";
    strVar += "  padding: 0;";
    strVar += "}";
    strVar += "";
    strVar += "table,";
    strVar += "tr,";
    strVar += "td {";
    strVar += "  vertical-align: top;";
    strVar += "  border-collapse: collapse;";
    strVar += "}";
    strVar += "";
    strVar += "p {";
    strVar += "  margin: 0;";
    strVar += "}";
    strVar += "";
    strVar += ".ie-container table,";
    strVar += ".mso-container table {";
    strVar += "  table-layout: fixed;";
    strVar += "}";
    strVar += "";
    strVar += "* {";
    strVar += "  line-height: inherit;";
    strVar += "}";
    strVar += "";
    strVar += "a[x-apple-data-detectors='true'] {";
    strVar += "  color: inherit !important;";
    strVar += "  text-decoration: none !important;";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 480px) {";
    strVar += "  .hide-mobile {";
    strVar += "    max-height: 0px;";
    strVar += "    overflow: hidden;";
    strVar += "    display: none !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "table, td { color: #000000; } a { color: #0000ee; text-decoration: underline; } @media (max-width: 480px) { #u_content_image_1 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_1 .v-src-width { width: auto !important; } #u_content_image_1 .v-src-max-width { max-width: 66% !important; } #u_content_image_2 .v-src-width { width: auto !important; } #u_content_image_2 .v-src-max-width { max-width: 55% !important; } #u_content_image_5 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_5 .v-src-width { width: auto !important; } #u_content_image_5 .v-src-max-width { max-width: 45% !important; } #u_content_image_5 .v-text-align { text-align: center !important; } #u_content_image_4 .v-container-padding-padding { padding: 10px 10px 30px !important; } #u_content_image_4 .v-src-width { width: auto !important; } #u_content_image_4 .v-src-max-width { max-width: 45% !important; } #u_content_image_4 .v-text-align { text-align: center !important; } #u_content_menu_1 .v-container-padding-padding { padding: 10px !important; } }";
    strVar += "    <\/style>";
    strVar += "  ";
    strVar += "  ";
    strVar += "";
    strVar += "<link href=\"https:\/\/fonts.googleapis.com\/css?family=Cabin:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><link href=\"https:\/\/fonts.googleapis.com\/css?family=Lato:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\">";
    strVar += "";
    strVar += "<\/head>";
    strVar += "";
    strVar += "<body class=\"clean-body u_body\" style=\"margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #e0e5eb;color: #000000\">";
    strVar += "  <!--[if IE]><div class=\"ie-container\"><![endif]-->";
    strVar += "  <!--[if mso]><div class=\"mso-container\"><![endif]-->";
    strVar += "  <table style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #e0e5eb;width:100%\" cellpadding=\"0\" cellspacing=\"0\">";
    strVar += "  <tbody>";
    strVar += "  <tr style=\"vertical-align: top\">";
    strVar += "    <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top\">";
    strVar += "    <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td align=\"center\" style=\"background-color: #e0e5eb;\"><![endif]-->";
    strVar += "    ";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px 10px 30px 50px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\">";
    strVar += "      <img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-3.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 34%;max-width: 73.1px;\" width=\"73.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      <\/a>";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ebebeb;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ebebeb;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:15px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h1 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: comic sans ms,sans-serif; font-size: 35px;\">";
    strVar += "    " + t('ciao_m') + nome + t('benvenuto_m');
    strVar += "  <\/h1>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px 30px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h3 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: book antiqua,palatino; font-size: 18px;\">";
    strVar += "    " + t('account_creato_m');
    strVar += "  <\/h3>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ebebeb;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ebebeb;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_2\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"center\">";
    strVar += "      ";
    strVar += "      <img align=\"center\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-4.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 39%;max-width: 191.1px;\" width=\"191.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('clicca_m') + "<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"v-text-align\" align=\"center\">";
    strVar += "  <!--[if mso]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;\"><tr><td class=\"v-text-align\" style=\"font-family:'Lato',sans-serif;\" align=\"center\"><v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" style=\"height:39px; v-text-anchor:middle; width:98px;\" arcsize=\"14%\" stroke=\"f\" fillcolor=\"#e67e23\"><w:anchorlock\/><center style=\"color:#ffffff;font-family:'Lato',sans-serif;\"><![endif]-->";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" target=\"_blank\" style=\"box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #ffffff; background-color: #e67e23; border-radius: 10px 1px 10px 1px;-webkit-border-radius: 10px 1px 10px 1px; -moz-border-radius: 10px 1px 10px 1px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;border-top-width: 0px; border-top-style: solid; border-top-color: #CCC; border-left-width: 0px; border-left-style: solid; border-left-color: #CCC; border-right-width: 0px; border-right-style: solid; border-right-color: #CCC; border-bottom-width: 0px; border-bottom-style: solid; border-bottom-color: #CCC;\">";
    strVar += "      <span style=\"display:block;padding:10px 30px;line-height:120%;\"><span style=\"font-size: 16px; line-height: 19.2px; font-family: Lato, sans-serif;\">Login<\/span><\/span>";
    strVar += "    <\/a>";
    strVar += "  <!--[if mso]><\/center><\/v:roundrect><\/td><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_5\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"right\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/apps.apple.com\/us\/app\/appius-academy\/id1630916391\"><img align=\"right\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-1.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 139.65px;\" width=\"139.65\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_4\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/play.google.com\/store\/apps\/details?id=com.appiusacademy\"><img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-2.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 133.95px;\" width=\"133.95\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_menu_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"menu\" style=\"text-align:center\">";
    strVar += "<!--[if (mso)|(IE)]><table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\"><tr><![endif]-->";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('chi_siamo');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "    <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "    <span style=\"padding:5px 15px;display:inline-block;color:#7e8c8d;font-family:'Cabin',sans-serif;font-size:14px\" class=\"hide-mobile\">";
    strVar += "      |";
    strVar += "    <\/span>";
    strVar += "    <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"mailto:info@appius.it?subject=Info%20Appius%20Academy&body=\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('contattaci_m');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if (mso)|(IE)]><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 10px 15px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #7e8c8d; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\">&copy; 2022 Appius Srls. All Rights Reserved.<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "    <!--[if (mso)|(IE)]><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "  <\/table>";
    strVar += "  <!--[if mso]><\/div><![endif]-->";
    strVar += "  <!--[if IE]><\/div><![endif]-->";
    strVar += "<\/body>";
    strVar += "";
    strVar += "<\/html>";
    strVar += "";
    
    return strVar;
}

export function studentCredenzialiMail(username, password, ragSoc, db, user_token, gender) {

    let t = translateString;

    var strVar="";
    strVar += "<!DOCTYPE HTML PUBLIC \"-\/\/W3C\/\/DTD XHTML 1.0 Transitional \/\/EN\" \"http:\/\/www.w3.org\/TR\/xhtml1\/DTD\/xhtml1-transitional.dtd\">";
    strVar += "<html xmlns=\"http:\/\/www.w3.org\/1999\/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">";
    strVar += "<head>";
    strVar += "<!--[if gte mso 9]>";
    strVar += "<xml>";
    strVar += "  <o:OfficeDocumentSettings>";
    strVar += "    <o:AllowPNG\/>";
    strVar += "    <o:PixelsPerInch>96<\/o:PixelsPerInch>";
    strVar += "  <\/o:OfficeDocumentSettings>";
    strVar += "<\/xml>";
    strVar += "<![endif]-->";
    strVar += "  <meta http-equiv=\"Content-Type\" content=\"text\/html; charset=UTF-8\">";
    strVar += "  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">";
    strVar += "  <meta name=\"x-apple-disable-message-reformatting\">";
    strVar += "  <!--[if !mso]><!--><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><!--<![endif]-->";
    strVar += "  <title><\/title>";
    strVar += "  ";
    strVar += "    <style type=\"text\/css\">";
    strVar += "      @media only screen and (min-width: 570px) {";
    strVar += "  .u-row {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    vertical-align: top;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-50 {";
    strVar += "    width: 275px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-100 {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 570px) {";
    strVar += "  .u-row-container {";
    strVar += "    max-width: 100% !important;";
    strVar += "    padding-left: 0px !important;";
    strVar += "    padding-right: 0px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    min-width: 320px !important;";
    strVar += "    max-width: 100% !important;";
    strVar += "    display: block !important;";
    strVar += "  }";
    strVar += "  .u-row {";
    strVar += "    width: calc(100% - 40px) !important;";
    strVar += "  }";
    strVar += "  .u-col {";
    strVar += "    width: 100% !important;";
    strVar += "  }";
    strVar += "  .u-col > div {";
    strVar += "    margin: 0 auto;";
    strVar += "  }";
    strVar += "}";
    strVar += "body {";
    strVar += "  margin: 0;";
    strVar += "  padding: 0;";
    strVar += "}";
    strVar += "";
    strVar += "table,";
    strVar += "tr,";
    strVar += "td {";
    strVar += "  vertical-align: top;";
    strVar += "  border-collapse: collapse;";
    strVar += "}";
    strVar += "";
    strVar += "p {";
    strVar += "  margin: 0;";
    strVar += "}";
    strVar += "";
    strVar += ".ie-container table,";
    strVar += ".mso-container table {";
    strVar += "  table-layout: fixed;";
    strVar += "}";
    strVar += "";
    strVar += "* {";
    strVar += "  line-height: inherit;";
    strVar += "}";
    strVar += "";
    strVar += "a[x-apple-data-detectors='true'] {";
    strVar += "  color: inherit !important;";
    strVar += "  text-decoration: none !important;";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 480px) {";
    strVar += "  .hide-mobile {";
    strVar += "    max-height: 0px;";
    strVar += "    overflow: hidden;";
    strVar += "    display: none !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "table, td { color: #000000; } a { color: #0000ee; text-decoration: underline; } @media (max-width: 480px) { #u_content_image_1 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_1 .v-src-width { width: auto !important; } #u_content_image_1 .v-src-max-width { max-width: 66% !important; } #u_content_image_2 .v-src-width { width: 100% !important; } #u_content_image_2 .v-src-max-width { max-width: 100% !important; } #u_content_image_5 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_5 .v-src-width { width: auto !important; } #u_content_image_5 .v-src-max-width { max-width: 45% !important; } #u_content_image_5 .v-text-align { text-align: center !important; } #u_content_image_4 .v-container-padding-padding { padding: 10px 10px 30px !important; } #u_content_image_4 .v-src-width { width: auto !important; } #u_content_image_4 .v-src-max-width { max-width: 45% !important; } #u_content_image_4 .v-text-align { text-align: center !important; } #u_content_menu_1 .v-container-padding-padding { padding: 10px !important; } }";
    strVar += "    <\/style>";
    strVar += "  ";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if !mso]><!--><link href=\"https:\/\/fonts.googleapis.com\/css?family=Cabin:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><link href=\"https:\/\/fonts.googleapis.com\/css?family=Lato:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><!--<![endif]-->";
    strVar += "";
    strVar += "<\/head>";
    strVar += "";
    strVar += "<body class=\"clean-body u_body\" style=\"margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #e0e5eb;color: #000000\">";
    strVar += "  <!--[if IE]><div class=\"ie-container\"><![endif]-->";
    strVar += "  <!--[if mso]><div class=\"mso-container\"><![endif]-->";
    strVar += "  <table style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #e0e5eb;width:100%\" cellpadding=\"0\" cellspacing=\"0\">";
    strVar += "  <tbody>";
    strVar += "  <tr style=\"vertical-align: top\">";
    strVar += "    <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top\">";
    strVar += "    <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td align=\"center\" style=\"background-color: #e0e5eb;\"><![endif]-->";
    strVar += "    ";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px 10px 30px 50px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\">";
    strVar += "      <img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-3.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 34%;max-width: 73.1px;\" width=\"73.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      <\/a>";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:15px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h1 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: comic sans ms,sans-serif; font-size: 35px;\">";
    strVar += "    Ciao!";
    strVar += "  <\/h1>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px 30px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h3 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: book antiqua,palatino; font-size: 18px;\">";
    if (t('language_string') === 'it') {
        strVar += gender === "M" ? "    Sei stato aggiunto come studente da " + ragSoc : gender === "F" ? "    Sei stata aggiunta come studentessa da " + ragSoc :  "    Sei stat* aggiunt* come studente da " + ragSoc;
    } else {
        strVar += "    You have been added as student by " + ragSoc;
    }
    strVar += "  <\/h3>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_2\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"center\">";
    strVar += "      ";
    strVar += "      <img align=\"center\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-6.jpg\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 100%;max-width: 550px;\" width=\"550\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 100px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('tue_c_m') + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;<\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('cliente_m') + " " + db + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('user_m') +" " + username + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('pass_m') + " " + password + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">Puoi accedere al portale studenti direttamente dal tuo computer cliccando sul pulsante qui sotto.<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"v-text-align\" align=\"center\">";
    strVar += "  <!--[if mso]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;\"><tr><td class=\"v-text-align\" style=\"font-family:'Lato',sans-serif;\" align=\"center\"><v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" style=\"height:39px; v-text-anchor:middle; width:131px;\" arcsize=\"14%\" stroke=\"f\" fillcolor=\"#e67e23\"><w:anchorlock\/><center style=\"color:#ffffff;font-family:'Lato',sans-serif;\"><![endif]-->";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\/" + db + "\" target=\"_blank\" style=\"box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #ffffff; background-color: #e67e23; border-radius: 10px 1px 10px 1px;-webkit-border-radius: 10px 1px 10px 1px; -moz-border-radius: 10px 1px 10px 1px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;border-top-width: 0px; border-top-style: solid; border-top-color: #CCC; border-left-width: 0px; border-left-style: solid; border-left-color: #CCC; border-right-width: 0px; border-right-style: solid; border-right-color: #CCC; border-bottom-width: 0px; border-bottom-style: solid; border-bottom-color: #CCC;\">";
    strVar += "      <span style=\"display:block;padding:10px 30px;line-height:120%;\"><span style=\"font-size: 16px; line-height: 19.2px; font-family: Lato, sans-serif;\">Login web<\/span><\/span>";
    strVar += "    <\/a>";
    strVar += "  <!--[if mso]><\/center><\/v:roundrect><\/td><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('istr_accesso') +"<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"v-text-align\" align=\"center\">";
    strVar += "  <!--[if mso]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;\"><tr><td class=\"v-text-align\" style=\"font-family:'Lato',sans-serif;\" align=\"center\"><v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" style=\"height:39px; v-text-anchor:middle; width:149px;\" arcsize=\"14%\" stroke=\"f\" fillcolor=\"#e67e23\"><w:anchorlock\/><center style=\"color:#ffffff;font-family:'Lato',sans-serif;\"><![endif]-->";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\/usertoken#\/usertoken?token=" + user_token + "&db=" + db + "\" target=\"_blank\" style=\"box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #ffffff; background-color: #e67e23; border-radius: 10px 1px 10px 1px;-webkit-border-radius: 10px 1px 10px 1px; -moz-border-radius: 10px 1px 10px 1px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;border-top-width: 0px; border-top-style: solid; border-top-color: #CCC; border-left-width: 0px; border-left-style: solid; border-left-color: #CCC; border-right-width: 0px; border-right-style: solid; border-right-color: #CCC; border-bottom-width: 0px; border-bottom-style: solid; border-bottom-color: #CCC;\">";
    strVar += "      <span style=\"display:block;padding:10px 30px;line-height:120%;\"><span style=\"font-size: 16px; line-height: 19.2px; font-family: Lato, sans-serif;\">Login mobile<\/span><\/span>";
    strVar += "    <\/a>";
    strVar += "  <!--[if mso]><\/center><\/v:roundrect><\/td><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_5\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"right\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/apps.apple.com\/us\/app\/appius-academy\/id1630916391\"><img align=\"right\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-1.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 139.65px;\" width=\"139.65\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_4\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/play.google.com\/store\/apps\/details?id=com.appiusacademy\"><img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-2.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 133.95px;\" width=\"133.95\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_menu_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"menu\" style=\"text-align:center\">";
    strVar += "<!--[if (mso)|(IE)]><table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\"><tr><![endif]-->";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('chi_siamo');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "    <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "    <span style=\"padding:5px 15px;display:inline-block;color:#7e8c8d;font-family:'Cabin',sans-serif;font-size:14px\" class=\"hide-mobile\">";
    strVar += "      |";
    strVar += "    <\/span>";
    strVar += "    <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"mailto:info@appius.it?subject=Info%20Appius%20Academy&body=\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('contattaci_m');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if (mso)|(IE)]><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 10px 15px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #7e8c8d; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\">&copy; 2022 Appius Srls. All Rights Reserved.<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "    <!--[if (mso)|(IE)]><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "  <\/table>";
    strVar += "  <!--[if mso]><\/div><![endif]-->";
    strVar += "  <!--[if IE]><\/div><![endif]-->";
    strVar += "<\/body>";
    strVar += "";
    strVar += "<\/html>";
    strVar += "";

    return strVar;
}

export function teacherCredentialsMail(username, password, ragSoc, db, user_token, gender) {

    let t = translateString;

    var strVar="";
    strVar += "<!DOCTYPE HTML PUBLIC \"-\/\/W3C\/\/DTD XHTML 1.0 Transitional \/\/EN\" \"http:\/\/www.w3.org\/TR\/xhtml1\/DTD\/xhtml1-transitional.dtd\">";
    strVar += "<html xmlns=\"http:\/\/www.w3.org\/1999\/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">";
    strVar += "<head>";
    strVar += "<!--[if gte mso 9]>";
    strVar += "<xml>";
    strVar += "  <o:OfficeDocumentSettings>";
    strVar += "    <o:AllowPNG\/>";
    strVar += "    <o:PixelsPerInch>96<\/o:PixelsPerInch>";
    strVar += "  <\/o:OfficeDocumentSettings>";
    strVar += "<\/xml>";
    strVar += "<![endif]-->";
    strVar += "  <meta http-equiv=\"Content-Type\" content=\"text\/html; charset=UTF-8\">";
    strVar += "  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">";
    strVar += "  <meta name=\"x-apple-disable-message-reformatting\">";
    strVar += "  <!--[if !mso]><!--><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><!--<![endif]-->";
    strVar += "  <title><\/title>";
    strVar += "  ";
    strVar += "    <style type=\"text\/css\">";
    strVar += "      @media only screen and (min-width: 570px) {";
    strVar += "  .u-row {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    vertical-align: top;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-50 {";
    strVar += "    width: 275px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-100 {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 570px) {";
    strVar += "  .u-row-container {";
    strVar += "    max-width: 100% !important;";
    strVar += "    padding-left: 0px !important;";
    strVar += "    padding-right: 0px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    min-width: 320px !important;";
    strVar += "    max-width: 100% !important;";
    strVar += "    display: block !important;";
    strVar += "  }";
    strVar += "  .u-row {";
    strVar += "    width: calc(100% - 40px) !important;";
    strVar += "  }";
    strVar += "  .u-col {";
    strVar += "    width: 100% !important;";
    strVar += "  }";
    strVar += "  .u-col > div {";
    strVar += "    margin: 0 auto;";
    strVar += "  }";
    strVar += "}";
    strVar += "body {";
    strVar += "  margin: 0;";
    strVar += "  padding: 0;";
    strVar += "}";
    strVar += "";
    strVar += "table,";
    strVar += "tr,";
    strVar += "td {";
    strVar += "  vertical-align: top;";
    strVar += "  border-collapse: collapse;";
    strVar += "}";
    strVar += "";
    strVar += "p {";
    strVar += "  margin: 0;";
    strVar += "}";
    strVar += "";
    strVar += ".ie-container table,";
    strVar += ".mso-container table {";
    strVar += "  table-layout: fixed;";
    strVar += "}";
    strVar += "";
    strVar += "* {";
    strVar += "  line-height: inherit;";
    strVar += "}";
    strVar += "";
    strVar += "a[x-apple-data-detectors='true'] {";
    strVar += "  color: inherit !important;";
    strVar += "  text-decoration: none !important;";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 480px) {";
    strVar += "  .hide-mobile {";
    strVar += "    max-height: 0px;";
    strVar += "    overflow: hidden;";
    strVar += "    display: none !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "table, td { color: #000000; } a { color: #0000ee; text-decoration: underline; } @media (max-width: 480px) { #u_content_image_1 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_1 .v-src-width { width: auto !important; } #u_content_image_1 .v-src-max-width { max-width: 66% !important; } #u_content_image_2 .v-src-width { width: 100% !important; } #u_content_image_2 .v-src-max-width { max-width: 100% !important; } #u_content_image_5 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_5 .v-src-width { width: auto !important; } #u_content_image_5 .v-src-max-width { max-width: 45% !important; } #u_content_image_5 .v-text-align { text-align: center !important; } #u_content_image_4 .v-container-padding-padding { padding: 10px 10px 30px !important; } #u_content_image_4 .v-src-width { width: auto !important; } #u_content_image_4 .v-src-max-width { max-width: 45% !important; } #u_content_image_4 .v-text-align { text-align: center !important; } #u_content_menu_1 .v-container-padding-padding { padding: 10px !important; } }";
    strVar += "    <\/style>";
    strVar += "  ";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if !mso]><!--><link href=\"https:\/\/fonts.googleapis.com\/css?family=Cabin:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><link href=\"https:\/\/fonts.googleapis.com\/css?family=Lato:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><!--<![endif]-->";
    strVar += "";
    strVar += "<\/head>";
    strVar += "";
    strVar += "<body class=\"clean-body u_body\" style=\"margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #e0e5eb;color: #000000\">";
    strVar += "  <!--[if IE]><div class=\"ie-container\"><![endif]-->";
    strVar += "  <!--[if mso]><div class=\"mso-container\"><![endif]-->";
    strVar += "  <table style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #e0e5eb;width:100%\" cellpadding=\"0\" cellspacing=\"0\">";
    strVar += "  <tbody>";
    strVar += "  <tr style=\"vertical-align: top\">";
    strVar += "    <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top\">";
    strVar += "    <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td align=\"center\" style=\"background-color: #e0e5eb;\"><![endif]-->";
    strVar += "    ";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px 10px 30px 50px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\">";
    strVar += "      <img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-3.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 34%;max-width: 73.1px;\" width=\"73.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      <\/a>";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:15px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h1 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: comic sans ms,sans-serif; font-size: 35px;\">";
    if (t('language_string') === 'it') {
        strVar += "    Ciao!";
    } else {
        strVar += "    Hi!";
    }
    strVar += "  <\/h1>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px 30px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h3 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: book antiqua,palatino; font-size: 18px;\">";
    if (t('language_string') === 'it') {
        strVar += gender === "M" ? "    Sei stato aggiunto come insegnante da " + ragSoc : gender === "F" ? "    Sei stata aggiunta come insegnante da " + ragSoc :  "    Sei stat* aggiunt* come insegnante da " + ragSoc;
    } else {
        strVar += "    You have been added as a teacher by " + ragSoc;
    }
    strVar += "  <\/h3>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_2\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"center\">";
    strVar += "      ";
    strVar += "      <img align=\"center\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-7.jpg\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 100%;max-width: 550px;\" width=\"550\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 100px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('tue_c_m') + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;<\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('cliente_m') + " " + db + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('user_m') + " " + username + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('pass_m') + " " + password + "<\/span><\/p>";
    strVar += "<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">Puoi accedere al portale insegnanti direttamente dal tuo computer cliccando sul pulsante qui sotto.<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"v-text-align\" align=\"center\">";
    strVar += "  <!--[if mso]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;\"><tr><td class=\"v-text-align\" style=\"font-family:'Lato',sans-serif;\" align=\"center\"><v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" style=\"height:39px; v-text-anchor:middle; width:131px;\" arcsize=\"14%\" stroke=\"f\" fillcolor=\"#e67e23\"><w:anchorlock\/><center style=\"color:#ffffff;font-family:'Lato',sans-serif;\"><![endif]-->";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\/" + db + "\" target=\"_blank\" style=\"box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #ffffff; background-color: #e67e23; border-radius: 10px 1px 10px 1px;-webkit-border-radius: 10px 1px 10px 1px; -moz-border-radius: 10px 1px 10px 1px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;border-top-width: 0px; border-top-style: solid; border-top-color: #CCC; border-left-width: 0px; border-left-style: solid; border-left-color: #CCC; border-right-width: 0px; border-right-style: solid; border-right-color: #CCC; border-bottom-width: 0px; border-bottom-style: solid; border-bottom-color: #CCC;\">";
    strVar += "      <span style=\"display:block;padding:10px 30px;line-height:120%;\"><span style=\"font-size: 16px; line-height: 19.2px; font-family: Lato, sans-serif;\">Login web<\/span><\/span>";
    strVar += "    <\/a>";
    strVar += "  <!--[if mso]><\/center><\/v:roundrect><\/td><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('istr_accesso') + "<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"v-text-align\" align=\"center\">";
    strVar += "  <!--[if mso]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;\"><tr><td class=\"v-text-align\" style=\"font-family:'Lato',sans-serif;\" align=\"center\"><v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" style=\"height:39px; v-text-anchor:middle; width:149px;\" arcsize=\"14%\" stroke=\"f\" fillcolor=\"#e67e23\"><w:anchorlock\/><center style=\"color:#ffffff;font-family:'Lato',sans-serif;\"><![endif]-->";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\/usertoken#/usertoken?token=" + user_token + "&db=" + db + "\" target=\"_blank\" style=\"box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #ffffff; background-color: #e67e23; border-radius: 10px 1px 10px 1px;-webkit-border-radius: 10px 1px 10px 1px; -moz-border-radius: 10px 1px 10px 1px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;border-top-width: 0px; border-top-style: solid; border-top-color: #CCC; border-left-width: 0px; border-left-style: solid; border-left-color: #CCC; border-right-width: 0px; border-right-style: solid; border-right-color: #CCC; border-bottom-width: 0px; border-bottom-style: solid; border-bottom-color: #CCC;\">";
    strVar += "      <span style=\"display:block;padding:10px 30px;line-height:120%;\"><span style=\"font-size: 16px; line-height: 19.2px; font-family: Lato, sans-serif;\">Login mobile<\/span><\/span>";
    strVar += "    <\/a>";
    strVar += "  <!--[if mso]><\/center><\/v:roundrect><\/td><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('consiglio_insegnanti') + "<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_5\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"right\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/apps.apple.com\/us\/app\/appius-academy\/id1630916391\"><img align=\"right\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-1.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 139.65px;\" width=\"139.65\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_4\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/play.google.com\/store\/apps\/details?id=com.appiusacademy\"><img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-2.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 133.95px;\" width=\"133.95\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_menu_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"menu\" style=\"text-align:center\">";
    strVar += "<!--[if (mso)|(IE)]><table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\"><tr><![endif]-->";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('chi_siamo');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "    <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "    <span style=\"padding:5px 15px;display:inline-block;color:#7e8c8d;font-family:'Cabin',sans-serif;font-size:14px\" class=\"hide-mobile\">";
    strVar += "      |";
    strVar += "    <\/span>";
    strVar += "    <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"mailto:info@appius.it?subject=Info%20Appius%20Academy&body=\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('contattaci_m');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if (mso)|(IE)]><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 10px 15px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #7e8c8d; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\">&copy; 2022 Appius Srls. All Rights Reserved.<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "    <!--[if (mso)|(IE)]><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "  <\/table>";
    strVar += "  <!--[if mso]><\/div><![endif]-->";
    strVar += "  <!--[if IE]><\/div><![endif]-->";
    strVar += "<\/body>";
    strVar += "";
    strVar += "<\/html>";
    strVar += "";

    return strVar;
}

export function gonePremiumBody(ragSoc) {
    let t = translateString;

    var strVar="";
    strVar += "<!DOCTYPE HTML PUBLIC \"-\/\/W3C\/\/DTD XHTML 1.0 Transitional \/\/EN\" \"http:\/\/www.w3.org\/TR\/xhtml1\/DTD\/xhtml1-transitional.dtd\">";
    strVar += "<html xmlns=\"http:\/\/www.w3.org\/1999\/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">";
    strVar += "<head>";
    strVar += "<!--[if gte mso 9]>";
    strVar += "<xml>";
    strVar += "  <o:OfficeDocumentSettings>";
    strVar += "    <o:AllowPNG\/>";
    strVar += "    <o:PixelsPerInch>96<\/o:PixelsPerInch>";
    strVar += "  <\/o:OfficeDocumentSettings>";
    strVar += "<\/xml>";
    strVar += "<![endif]-->";
    strVar += "  <meta http-equiv=\"Content-Type\" content=\"text\/html; charset=UTF-8\">";
    strVar += "  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">";
    strVar += "  <meta name=\"x-apple-disable-message-reformatting\">";
    strVar += "  <!--[if !mso]><!--><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><!--<![endif]-->";
    strVar += "  <title><\/title>";
    strVar += "  ";
    strVar += "    <style type=\"text\/css\">";
    strVar += "      @media only screen and (min-width: 570px) {";
    strVar += "  .u-row {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    vertical-align: top;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-50 {";
    strVar += "    width: 275px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-100 {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 570px) {";
    strVar += "  .u-row-container {";
    strVar += "    max-width: 100% !important;";
    strVar += "    padding-left: 0px !important;";
    strVar += "    padding-right: 0px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    min-width: 320px !important;";
    strVar += "    max-width: 100% !important;";
    strVar += "    display: block !important;";
    strVar += "  }";
    strVar += "  .u-row {";
    strVar += "    width: calc(100% - 40px) !important;";
    strVar += "  }";
    strVar += "  .u-col {";
    strVar += "    width: 100% !important;";
    strVar += "  }";
    strVar += "  .u-col > div {";
    strVar += "    margin: 0 auto;";
    strVar += "  }";
    strVar += "}";
    strVar += "body {";
    strVar += "  margin: 0;";
    strVar += "  padding: 0;";
    strVar += "}";
    strVar += "";
    strVar += "table,";
    strVar += "tr,";
    strVar += "td {";
    strVar += "  vertical-align: top;";
    strVar += "  border-collapse: collapse;";
    strVar += "}";
    strVar += "";
    strVar += "p {";
    strVar += "  margin: 0;";
    strVar += "}";
    strVar += "";
    strVar += ".ie-container table,";
    strVar += ".mso-container table {";
    strVar += "  table-layout: fixed;";
    strVar += "}";
    strVar += "";
    strVar += "* {";
    strVar += "  line-height: inherit;";
    strVar += "}";
    strVar += "";
    strVar += "a[x-apple-data-detectors='true'] {";
    strVar += "  color: inherit !important;";
    strVar += "  text-decoration: none !important;";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 480px) {";
    strVar += "  .hide-mobile {";
    strVar += "    max-height: 0px;";
    strVar += "    overflow: hidden;";
    strVar += "    display: none !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "table, td { color: #000000; } a { color: #0000ee; text-decoration: underline; } @media (max-width: 480px) { #u_content_image_1 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_1 .v-src-width { width: auto !important; } #u_content_image_1 .v-src-max-width { max-width: 66% !important; } #u_content_image_2 .v-src-width { width: 100% !important; } #u_content_image_2 .v-src-max-width { max-width: 100% !important; } #u_content_image_5 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_5 .v-src-width { width: auto !important; } #u_content_image_5 .v-src-max-width { max-width: 45% !important; } #u_content_image_5 .v-text-align { text-align: center !important; } #u_content_image_4 .v-container-padding-padding { padding: 10px 10px 30px !important; } #u_content_image_4 .v-src-width { width: auto !important; } #u_content_image_4 .v-src-max-width { max-width: 45% !important; } #u_content_image_4 .v-text-align { text-align: center !important; } #u_content_menu_1 .v-container-padding-padding { padding: 10px !important; } }";
    strVar += "    <\/style>";
    strVar += "  ";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if !mso]><!--><link href=\"https:\/\/fonts.googleapis.com\/css?family=Cabin:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><link href=\"https:\/\/fonts.googleapis.com\/css?family=Lato:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><!--<![endif]-->";
    strVar += "";
    strVar += "<\/head>";
    strVar += "";
    strVar += "<body class=\"clean-body u_body\" style=\"margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #e0e5eb;color: #000000\">";
    strVar += "  <!--[if IE]><div class=\"ie-container\"><![endif]-->";
    strVar += "  <!--[if mso]><div class=\"mso-container\"><![endif]-->";
    strVar += "  <table style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #e0e5eb;width:100%\" cellpadding=\"0\" cellspacing=\"0\">";
    strVar += "  <tbody>";
    strVar += "  <tr style=\"vertical-align: top\">";
    strVar += "    <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top\">";
    strVar += "    <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td align=\"center\" style=\"background-color: #e0e5eb;\"><![endif]-->";
    strVar += "    ";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px 10px 30px 50px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\">";
    strVar += "      <img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-3.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 34%;max-width: 73.1px;\" width=\"73.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      <\/a>";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:15px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h1 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: comic sans ms,sans-serif; font-size: 35px;\">";
    if (t('language_string') === 'it') {
        strVar += "    Benvenuto nel mondo di Appius Academy PREMIUM, " + ragSoc + "!";
    } else {
        strVar += "    Welcome in the Appius Academy PREMIUM's world, " + ragSoc + "!";
    }
    strVar += "  <\/h1>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px 30px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h3 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: book antiqua,palatino; font-size: 18px;\">";
    strVar += "    " + t('ultimi_p');
    strVar += "  <\/h3>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_2\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"center\">";
    strVar += "      ";
    strVar += "      <img align=\"center\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-9.jpg\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 100%;max-width: 550px;\" width=\"550\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('fissa_chiamata_m') + "<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"v-text-align\" align=\"center\">";
    strVar += "  <!--[if mso]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;\"><tr><td class=\"v-text-align\" style=\"font-family:'Lato',sans-serif;\" align=\"center\"><v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https:\/\/www.Hdemia.cloud\/#\/main\/login\" style=\"height:39px; v-text-anchor:middle; width:131px;\" arcsize=\"14%\" stroke=\"f\" fillcolor=\"#e67e23\"><w:anchorlock\/><center style=\"color:#ffffff;font-family:'Lato',sans-serif;\"><![endif]-->";
    strVar += "    <a href=\"https://calendly.com/appius/30min\" target=\"_blank\" style=\"box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #ffffff; background-color: #e67e23; border-radius: 10px 1px 10px 1px;-webkit-border-radius: 10px 1px 10px 1px; -moz-border-radius: 10px 1px 10px 1px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;border-top-width: 0px; border-top-style: solid; border-top-color: #CCC; border-left-width: 0px; border-left-style: solid; border-left-color: #CCC; border-right-width: 0px; border-right-style: solid; border-right-color: #CCC; border-bottom-width: 0px; border-bottom-style: solid; border-bottom-color: #CCC;\">";
    strVar += "      <span style=\"display:block;padding:10px 30px;line-height:120%;\"><span style=\"font-size: 16px; line-height: 19.2px; font-family: Lato, sans-serif;\">" + t('fissa_una_call') + "<\/span><\/span>";
    strVar += "    <\/a>";
    strVar += "  <!--[if mso]><\/center><\/v:roundrect><\/td><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('ads_rimossi') + "<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_5\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"right\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/apps.apple.com\/us\/app\/appius-academy\/id1630916391\"><img align=\"right\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-1.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 139.65px;\" width=\"139.65\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_4\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/play.google.com\/store\/apps\/details?id=com.appiusacademy\"><img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-2.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 133.95px;\" width=\"133.95\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_menu_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"menu\" style=\"text-align:center\">";
    strVar += "<!--[if (mso)|(IE)]><table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\"><tr><![endif]-->";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('chi_siamo');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "    <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "    <span style=\"padding:5px 15px;display:inline-block;color:#7e8c8d;font-family:'Cabin',sans-serif;font-size:14px\" class=\"hide-mobile\">";
    strVar += "      |";
    strVar += "    <\/span>";
    strVar += "    <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"mailto:info@appius.it?subject=Info%20Appius%20Academy&body=\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('contattaci_m');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if (mso)|(IE)]><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 10px 15px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #7e8c8d; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\">&copy; 2022 Appius Srls. All Rights Reserved.<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "    <!--[if (mso)|(IE)]><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "  <\/table>";
    strVar += "  <!--[if mso]><\/div><![endif]-->";
    strVar += "  <!--[if IE]><\/div><![endif]-->";
    strVar += "<\/body>";
    strVar += "";
    strVar += "<\/html>";
    strVar += "";

    return strVar;
}

export function canceledSubscriptionBody(ragSoc) {

    let t = translateString;

    var strVar="";
    strVar += "<!DOCTYPE HTML PUBLIC \"-\/\/W3C\/\/DTD XHTML 1.0 Transitional \/\/EN\" \"http:\/\/www.w3.org\/TR\/xhtml1\/DTD\/xhtml1-transitional.dtd\">";
    strVar += "<html xmlns=\"http:\/\/www.w3.org\/1999\/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">";
    strVar += "<head>";
    strVar += "<!--[if gte mso 9]>";
    strVar += "<xml>";
    strVar += "  <o:OfficeDocumentSettings>";
    strVar += "    <o:AllowPNG\/>";
    strVar += "    <o:PixelsPerInch>96<\/o:PixelsPerInch>";
    strVar += "  <\/o:OfficeDocumentSettings>";
    strVar += "<\/xml>";
    strVar += "<![endif]-->";
    strVar += "  <meta http-equiv=\"Content-Type\" content=\"text\/html; charset=UTF-8\">";
    strVar += "  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">";
    strVar += "  <meta name=\"x-apple-disable-message-reformatting\">";
    strVar += "  <!--[if !mso]><!--><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><!--<![endif]-->";
    strVar += "  <title><\/title>";
    strVar += "  ";
    strVar += "    <style type=\"text\/css\">";
    strVar += "      @media only screen and (min-width: 570px) {";
    strVar += "  .u-row {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    vertical-align: top;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-50 {";
    strVar += "    width: 275px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "  .u-row .u-col-100 {";
    strVar += "    width: 550px !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 570px) {";
    strVar += "  .u-row-container {";
    strVar += "    max-width: 100% !important;";
    strVar += "    padding-left: 0px !important;";
    strVar += "    padding-right: 0px !important;";
    strVar += "  }";
    strVar += "  .u-row .u-col {";
    strVar += "    min-width: 320px !important;";
    strVar += "    max-width: 100% !important;";
    strVar += "    display: block !important;";
    strVar += "  }";
    strVar += "  .u-row {";
    strVar += "    width: calc(100% - 40px) !important;";
    strVar += "  }";
    strVar += "  .u-col {";
    strVar += "    width: 100% !important;";
    strVar += "  }";
    strVar += "  .u-col > div {";
    strVar += "    margin: 0 auto;";
    strVar += "  }";
    strVar += "}";
    strVar += "body {";
    strVar += "  margin: 0;";
    strVar += "  padding: 0;";
    strVar += "}";
    strVar += "";
    strVar += "table,";
    strVar += "tr,";
    strVar += "td {";
    strVar += "  vertical-align: top;";
    strVar += "  border-collapse: collapse;";
    strVar += "}";
    strVar += "";
    strVar += "p {";
    strVar += "  margin: 0;";
    strVar += "}";
    strVar += "";
    strVar += ".ie-container table,";
    strVar += ".mso-container table {";
    strVar += "  table-layout: fixed;";
    strVar += "}";
    strVar += "";
    strVar += "* {";
    strVar += "  line-height: inherit;";
    strVar += "}";
    strVar += "";
    strVar += "a[x-apple-data-detectors='true'] {";
    strVar += "  color: inherit !important;";
    strVar += "  text-decoration: none !important;";
    strVar += "}";
    strVar += "";
    strVar += "@media (max-width: 480px) {";
    strVar += "  .hide-mobile {";
    strVar += "    max-height: 0px;";
    strVar += "    overflow: hidden;";
    strVar += "    display: none !important;";
    strVar += "  }";
    strVar += "";
    strVar += "}";
    strVar += "table, td { color: #000000; } a { color: #0000ee; text-decoration: underline; } @media (max-width: 480px) { #u_content_image_1 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_1 .v-src-width { width: auto !important; } #u_content_image_1 .v-src-max-width { max-width: 66% !important; } #u_content_image_2 .v-src-width { width: 100% !important; } #u_content_image_2 .v-src-max-width { max-width: 100% !important; } #u_content_image_5 .v-container-padding-padding { padding: 30px 10px 10px !important; } #u_content_image_5 .v-src-width { width: auto !important; } #u_content_image_5 .v-src-max-width { max-width: 45% !important; } #u_content_image_5 .v-text-align { text-align: center !important; } #u_content_image_4 .v-container-padding-padding { padding: 10px 10px 30px !important; } #u_content_image_4 .v-src-width { width: auto !important; } #u_content_image_4 .v-src-max-width { max-width: 45% !important; } #u_content_image_4 .v-text-align { text-align: center !important; } #u_content_menu_1 .v-container-padding-padding { padding: 10px !important; } }";
    strVar += "    <\/style>";
    strVar += "  ";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if !mso]><!--><link href=\"https:\/\/fonts.googleapis.com\/css?family=Cabin:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><link href=\"https:\/\/fonts.googleapis.com\/css?family=Lato:400,700&display=swap\" rel=\"stylesheet\" type=\"text\/css\"><!--<![endif]-->";
    strVar += "";
    strVar += "<\/head>";
    strVar += "";
    strVar += "<body class=\"clean-body u_body\" style=\"margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #e0e5eb;color: #000000\">";
    strVar += "  <!--[if IE]><div class=\"ie-container\"><![endif]-->";
    strVar += "  <!--[if mso]><div class=\"mso-container\"><![endif]-->";
    strVar += "  <table style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #e0e5eb;width:100%\" cellpadding=\"0\" cellspacing=\"0\">";
    strVar += "  <tbody>";
    strVar += "  <tr style=\"vertical-align: top\">";
    strVar += "    <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top\">";
    strVar += "    <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td align=\"center\" style=\"background-color: #e0e5eb;\"><![endif]-->";
    strVar += "    ";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:30px 10px 30px 50px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\">";
    strVar += "      <img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-3.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 34%;max-width: 73.1px;\" width=\"73.1\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      <\/a>";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:15px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h1 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: comic sans ms,sans-serif; font-size: 35px;\">";
    if (t('language_string') === 'it') {
        strVar += "    Ci dispiace vederti andare via, " + ragSoc + "!";
    } else {
        strVar += "    We are sorry to see you go, " + ragSoc + "!";
    }
    strVar += "  <\/h1>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px 30px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <h3 class=\"v-text-align\" style=\"margin: 0px; color: #414141; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-family: book antiqua,palatino; font-size: 18px;\">";
    strVar += "    " + t('richiesta_ricevuta');
    strVar += "  <\/h3>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_2\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:0px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"center\">";
    strVar += "      ";
    strVar += "      <img align=\"center\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-10.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 100%;max-width: 550px;\" width=\"550\" class=\"v-src-width v-src-max-width\"\/>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('passaggi_chiusura') + "<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 40px 20px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #414141; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">" + t('uso_app') + "<\/span><\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_5\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"right\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/apps.apple.com\/us\/app\/appius-academy\/id1630916391\"><img align=\"right\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-1.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 139.65px;\" width=\"139.65\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"275\" style=\"width: 275px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-50\" style=\"max-width: 320px;min-width: 275px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_image_4\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:20px 20px 10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">";
    strVar += "  <tr>";
    strVar += "    <td class=\"v-text-align\" style=\"padding-right: 0px;padding-left: 0px;\" align=\"left\">";
    strVar += "      ";
    strVar += "      <a href=\"https:\/\/play.google.com\/store\/apps\/details?id=com.appiusacademy\"><img align=\"left\" border=\"0\" src=\"https://www.Hdemia.cloud\/mail_images\/image-2.png\" alt=\"Image\" title=\"Image\" style=\"outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 57%;max-width: 133.95px;\" width=\"133.95\" class=\"v-src-width v-src-max-width\"\/></a>";
    strVar += "      ";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #eef2f5;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #eef2f5;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: #ffffff;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table id=\"u_content_menu_1\" style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "<div class=\"menu\" style=\"text-align:center\">";
    strVar += "<!--[if (mso)|(IE)]><table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\"><tr><![endif]-->";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"https:\/\/www.Hdemia.cloud\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('chi_siamo');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "    <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "    <span style=\"padding:5px 15px;display:inline-block;color:#7e8c8d;font-family:'Cabin',sans-serif;font-size:14px\" class=\"hide-mobile\">";
    strVar += "      |";
    strVar += "    <\/span>";
    strVar += "    <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "  <!--[if (mso)|(IE)]><td style=\"padding:5px 15px\"><![endif]-->";
    strVar += "  ";
    strVar += "    <a href=\"mailto:info@appius.it?subject=Info%20Appius%20Academy&body=\" target=\"_blank\" style=\"padding:5px 15px;display:inline-block;color:#0068A5;font-family:'Cabin',sans-serif;font-size:14px;text-decoration:none\" >";
    strVar += "      " + t('contattaci_m');
    strVar += "    <\/a>";
    strVar += "  ";
    strVar += "  <!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "  ";
    strVar += "";
    strVar += "<!--[if (mso)|(IE)]><\/tr><\/table><![endif]-->";
    strVar += "<\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px 10px 15px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <div class=\"v-text-align\" style=\"color: #7e8c8d; line-height: 140%; text-align: center; word-wrap: break-word;\">";
    strVar += "    <p style=\"font-size: 14px; line-height: 140%;\">&copy; 2022 Appius Srls. All Rights Reserved.<\/p>";
    strVar += "  <\/div>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "";
    strVar += "<div class=\"u-row-container\" style=\"padding: 0px;background-color: transparent\">";
    strVar += "  <div class=\"u-row\" style=\"Margin: 0 auto;min-width: 320px;max-width: 550px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;\">";
    strVar += "    <div style=\"border-collapse: collapse;display: table;width: 100%;background-color: transparent;\">";
    strVar += "      <!--[if (mso)|(IE)]><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tr><td style=\"padding: 0px;background-color: transparent;\" align=\"center\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"width:550px;\"><tr style=\"background-color: transparent;\"><![endif]-->";
    strVar += "      ";
    strVar += "<!--[if (mso)|(IE)]><td align=\"center\" width=\"550\" style=\"width: 550px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\" valign=\"top\"><![endif]-->";
    strVar += "<div class=\"u-col u-col-100\" style=\"max-width: 320px;min-width: 550px;display: table-cell;vertical-align: top;\">";
    strVar += "  <div style=\"width: 100% !important;\">";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><div style=\"padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;\"><!--<![endif]-->";
    strVar += "  ";
    strVar += "<table style=\"font-family:'Lato',sans-serif;\" role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\">";
    strVar += "  <tbody>";
    strVar += "    <tr>";
    strVar += "      <td class=\"v-container-padding-padding\" style=\"overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:'Lato',sans-serif;\" align=\"left\">";
    strVar += "        ";
    strVar += "  <table height=\"0px\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "    <tbody>";
    strVar += "      <tr style=\"vertical-align: top\">";
    strVar += "        <td style=\"word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%\">";
    strVar += "          <span>&#160;<\/span>";
    strVar += "        <\/td>";
    strVar += "      <\/tr>";
    strVar += "    <\/tbody>";
    strVar += "  <\/table>";
    strVar += "";
    strVar += "      <\/td>";
    strVar += "    <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "<\/table>";
    strVar += "";
    strVar += "  <!--[if (!mso)&(!IE)]><!--><\/div><!--<![endif]-->";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "<!--[if (mso)|(IE)]><\/td><![endif]-->";
    strVar += "      <!--[if (mso)|(IE)]><\/tr><\/table><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/div>";
    strVar += "  <\/div>";
    strVar += "<\/div>";
    strVar += "";
    strVar += "";
    strVar += "    <!--[if (mso)|(IE)]><\/td><\/tr><\/table><![endif]-->";
    strVar += "    <\/td>";
    strVar += "  <\/tr>";
    strVar += "  <\/tbody>";
    strVar += "  <\/table>";
    strVar += "  <!--[if mso]><\/div><![endif]-->";
    strVar += "  <!--[if IE]><\/div><![endif]-->";
    strVar += "<\/body>";
    strVar += "";
    strVar += "<\/html>";
    strVar += "";

    return strVar;
}

export function getServiceName() {
    return 'Hdemia';
}